import {T} from '../../utils/I18n/I18n';
import {useTranslation} from "react-i18next";
import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import FormInput from '../../components/UI/FormInput/FormInput';
import SocialAuth from '../../components/UI/SocialAuth/SocialAuth';
import {usePopup} from '../../context/PopupContext';
import {useUserContext} from '../../context/UserContext';
import useApi from '../../hooks/useApi';
import {EMAIL_AVAILABLE} from '../../queries/auth';
import CheckoutFormField from './CheckoutFormField';
import {useCartContext} from "../../context/CartContext";

const CheckoutEmailOrLogin = ({register, errors, email, setEmail}) => {
  const {cart} = useCartContext();
  const [userFound, setUserFound] = useState(false);
  const { fetchQuery: getEmailAvailable } = useApi(EMAIL_AVAILABLE);
  const emailAvailableTimer = useRef(null);
  const { user, logIn, error } = useUserContext();
  const { showAddToCartPopupMessage } = usePopup();
  const { t } = useTranslation();
  useEffect(() => {
    if (error) {
      showAddToCartPopupMessage(t('login.wrongPassword'), 'error', 4000);
    }
  }, [error]);

  const isValidEmail=(email)=> {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  /** @type {React.ChangeEventHandler<HTMLInputElement>} */
  const onEmailChange = useCallback(


    e => {
        console.log('callback')
      if (user) {
        return;
      }
        const _email = e.currentTarget.value;
        if (!isValidEmail(_email)) {
        return;
      }
      if (emailAvailableTimer.current) {
        clearTimeout(emailAvailableTimer.current);
        emailAvailableTimer.current = null;
      }

      setUserFound(false);

      emailAvailableTimer.current = setTimeout(() => {
          getEmailAvailable({variables: {email: _email}}).then(({data}) => {
          setUserFound(data.isEmailAvailable && !data.isEmailAvailable.is_email_available);
              setEmail(_email)
        });
      }, 300);
    },
      [user, getEmailAvailable, setEmail],
  );

  /** @type {React.MouseEventHandler<HTMLButtonElement>} */
  const onRegisterClick = event => {
    const { form } = event.currentTarget;
      // const email = form.elements.namedItem('email').value;
    const password = form.elements.namedItem('password').value;

    if (email && password) {
      logIn(email, password);
    }
  };

  if (user) {
    return <></>;
  }

  return (
    <>
      {register && (
        <FormInput
          register={register}
          text={<T id="registration.email" />}
          id="email"
          name="email"
          type="email"
          value={cart.email}
          onChange={onEmailChange}
          errors={errors}
        />
      )}
      {!register && (
        <CheckoutFormField
          required
          label={<T id="registration.email" />}
          id="email"
          type="email"
          defaultValue={email}
          onChange={onEmailChange}
        />
      )}
      {!user && !userFound && (
        <div className="checkout__main__form__message">
          <T id="checkout.creatingProfileText" />
        </div>
      )}

      {userFound && register && (
        <FormInput
          register={register}
          register={register}
          text={<T id="registration.password" />}
          id="password"
          name="password"
          type="password"
          errors={errors}
        />
      )}
      {userFound && !register && (
        <CheckoutFormField label={<T id="registration.password" />} id="password" type="password" />
      )}

      {userFound && (
        <div className="user-found">
          <span>
            <T id="checkout.existingUser" />
          </span>

          <button type="button" className="checkout__btn checkout__btn--primary" onClick={onRegisterClick}>
              <T id="checkout.login"/>
          </button>

          <Link to="/customer/account/forgotpassword/">
            <T id="login.forgotPassword" />
          </Link>

          <span>
            <T id="checkout.facebookAndGoogleLoginText" />
          </span>

          <SocialAuth isCheckout />
        </div>
      )}
    </>
  );
};

export default CheckoutEmailOrLogin;
